declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    env: EnvType
  }
}

type EnvType = {
  NODE_ENV: string,
  REACT_APP_BACKEND_URL: string,
  REACT_APP_VERSION: string,
  REACT_APP_SENTRY_DSN: string,
  REACT_APP_RECAPTCHA_SITE_KEY: string,
  REACT_APP_DATADOG_APP_ID: string,
  REACT_APP_DATADOG_CLIENT_TOKEN: string,
};

export const env: EnvType = { ...process.env, ...window.env };
